import _ from "lodash";
import { Navigate, useLocation } from "react-router-dom";
import { getCurrentUser } from "./common/routines/user-operations";
import { useResourcePermissions } from "./common/hooks/resource-permissions";

interface ProtectedRouteProps {
  children: React.ReactElement;
  moduleName: string;
  fallbackPath?: string;
}

const ProtectedRoute = ({
  children,
  moduleName,
  fallbackPath = "/unauthorized",
}: ProtectedRouteProps) => {
  const { hasAnyPermission } = useResourcePermissions();

  const location = useLocation();
  const isAuthenticated = !_.isEmpty(getCurrentUser());
  const isHavingPermission = hasAnyPermission(moduleName, "read");
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isHavingPermission) {
    return (
      <Navigate to={fallbackPath} state={{ from: location.pathname }} replace />
    );
  }

  return children;
};

export default ProtectedRoute;
